module.exports = __webpack_public_path__ + "static/media/VeryStrong.365c6576.svg";